import { Modal, Button, ButtonToolbar, Placeholder } from 'rsuite';

export default function Declaration(props) {
    const { handleOpen, handleClose } = props;
  return (
    <Modal open={handleOpen} onClose={handleClose}>
    <Modal.Header>
      <Modal.Title>Modal Title</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Placeholder.Paragraph />
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={handleClose} appearance="primary">
        Ok
      </Button>
      <Button onClick={handleClose} appearance="subtle">
        Cancel
      </Button>
    </Modal.Footer>
  </Modal>
  )
}
